import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, ReplaySubject } from 'rxjs';
import {
  ApiClientService,
  ApiResponse
} from './../../shared/services/api-client.service';
import { AB_API_TRANSFERS_COUNTRYLIST } from './../../shared/constants';
interface CountryListResponse extends ApiResponse {
  list: any;
}

@Injectable({
  providedIn: 'root'
})
export class CountryListService extends ApiClientService {
  private cache: ReplaySubject<CountryListResponse>;

  constructor(http: HttpClient) {
    super(http, AB_API_TRANSFERS_COUNTRYLIST);
  }

  public get(): Observable<CountryListResponse> {
    if (!this.cache) {
      this.cache = new ReplaySubject<CountryListResponse>();
      super.get().subscribe(response => this.cache.next(response));
    }

    return this.cache.asObservable();
  }
}

export { CountryListResponse };
